

import {
	LoaderUtils,
	FileLoader,
	ObjectLoader as THREEJsObjectLoader
} from '../../src/js/three.module.js';

//import { MeshObjectLoader } from './loaders/mesh-object-loader.js';
import { getMeshObjectLoader, getObjectLoader } from './loaders/loader-manager.js';

export class ObjectLoader extends THREEJsObjectLoader {

	load( url, onLoad, onProgress, onError ) {

		var scope = this;

		var path = ( this.path === '' ) ? LoaderUtils.extractUrlBase( url ) : this.path;
		this.resourcePath = this.resourcePath || path;

		var loader = new FileLoader( scope.manager );
		loader.setPath( this.path );
		loader.load( url, function ( text ) {

			var json = null;

			try {

				json = JSON.parse( text );

			} catch ( error ) {

				if ( onError !== undefined ) onError( error );

				console.error( 'THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message );

				return;

			}

			var metadata = json.metadata;

			if (metadata && !metadata.type && json.scene && json.scene.metadata) {
				json = json.scene;
				metadata = json.metadata;
			}

			if ( metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry' ) {

				console.error( 'THREE.ObjectLoader: Can\'t load ' + url );
				return;

			}

			scope.parse( json, onLoad );

		}, onProgress, onError );
	} 

    static promiseLoad( url, onProgress ) {

		try {

			let loader = /* new MeshObjectLoader() */ getMeshObjectLoader();

			let type = loader.solveTypeByFilename( url );

			if (type && type != "json") {

				return loader.loadUrl( url );

			} else {

				return loader.loadUrl( url ).then( result => {

					return result;

				}).catch( error => {

					console.error( error );


					return fallback( url, onProgress );
				})
			}

		} catch (error) {
			console.error( error);
		}

		return fallback( url, onProgress );

		function fallback( url, onProgress ) {

			if (typeof onProgress != "function") {
				onProgress = ( xhr ) => {
					if (xhr.total == 0) {
						console.log( "Loading object from " + xhr.target.responseURL + "." );
					} else {
						console.log( "Loading object from " + xhr.target.responseURL + ". " + Math.round( xhr.loaded / xhr.total * 100 ) + "% downloaded");
					}
				};
			}


			return new Promise( function( onLoad, onError ) {
				/* new ObjectLoader() */getObjectLoader().load( url, onLoad, onProgress, onError );
			});
		}
	}
}